export default __webpack_public_path__ + "harvest-logo.9ac18feb.png";